import { StoreState } from "../../../store/store.interface";
import { waitForState } from '../../../store/store';

export const getSharpenSearchServiceProductStatus = (state: StoreState) => state.sharpenProductDataState.sharpenSearchServiceProductData.status;

export const getSharpenSearchServiceProductData = (state: StoreState) => state.sharpenProductDataState.sharpenSearchServiceProductData.data;

export const getCurrentSelectedSharpenUpsellData = (state: StoreState) => state.sharpenProductDataState.selectedSharpenUpsellProductData;

export const waitForSharpenSearchServiceProduct = async () => await waitForState(state => state.sharpenProductDataState.sharpenSearchServiceProductData);
